const ROOT = 'TIMESHEETS_';

const actions = {
  LOAD_TIMESHEETS_REQUEST: `${ROOT}LOAD_TIMESHEETS_REQUEST`,
  LOAD_TIMESHEETS_SUCCESS: `${ROOT}LOAD_TIMESHEETS_SUCCESS`,
  LOAD_TIMESHEETS_ERROR: `${ROOT}LOAD_TIMESHEETS_ERROR`,
  PROCESS_ACTION_REQUEST: `${ROOT}PROCESS_ACTION_REQUEST`,
  PROCESS_ACTION_SUCCESS: `${ROOT}PROCESS_ACTION_SUCCESS`,
  PROCESS_ACTION_ERROR: `${ROOT}PROCESS_ACTION_ERROR`,
  LOAD_TIMESHEET_ITEM_REQUEST: `${ROOT}LOAD_TIMESHEET_ITEM_REQUEST`,
  LOAD_TIMESHEET_ITEM_SUCCESS: `${ROOT}LOAD_TIMESHEET_ITEM_SUCCESS`,
  LOAD_TIMESHEET_ITEM_ERROR: `${ROOT}LOAD_TIMESHEET_ITEM_ERROR`,
  CHANGE_EDIT_HOURS_MODAL_VISIBILITY: `${ROOT}TOGGLE_EDIT_HOURS_MODAL`,
  MOVE_TIMESHEET_TO_RESOLVED: `${ROOT}MOVE_TIMESHEET_TO_RESOLVED`,
} as const;

export default actions;
